import { ChangeDetectorRef, Component, Inject, Input, OnInit, Optional, Renderer2 } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import config from 'config/default.json';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
@Component({
  selector: 'app-setting-user',
  templateUrl: './setting-user.component.html',
  styleUrls: ['./setting-user.component.scss']
})
export class SettingUserComponent implements OnInit{
  constructor(
      private apiService: ApiServiceModule,
      private helper: HelperModule,
      private cdRef: ChangeDetectorRef,
      private renderer: Renderer2,
      @Optional() public dialogRef: MatDialogRef<SettingUserComponent>,
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any
      ) {}
    @Input() action: string = '';
    @Input() countryData:{[x: string]: any}[] = [];
    @Input() functionData:{[x: string]: any}[] = [];
    @Input() rowInfos: any = new Map();
    @Input() userInfos: { [x:string]: any } = new Map();

    countryControl = new FormControl();
    firstNameControl = new FormControl();
    lastNameControl = new FormControl();
    emailControl = new FormControl();
    phoneControl = new FormControl();
    promoCodeControl = new FormControl();
    privilegeLevelControl = new FormControl();
    funcionControl = new FormControl();
    passwordControl = new FormControl();
    userManagerControl = new FormControl();
    userManagerSearchControl = new FormControl();
    contentAcquisitionControl = new FormControl();
    contentClassificationControl = new FormControl();
    contentEditionControl = new FormControl();

    usersManager:any[] = [];
    selectedUserManager: any = null;

    inProgress = false;

    enovskyPages = [{id_page: 'documentation', name: 'Documentation', icon: 'mark_unread_chat_alt'}, {id_page: 'user-admin', name: 'User Admin', icon: 'groups'}, {id_page: 'server-admin', name: 'Server Admin', icon: 'engineering'}, {id_page: 'management', name: 'Management', icon: 'business_center'}];
    virtualCampusPages = [{id_page: 'vca-content-project', name: 'Edit Content', 'icon': 'edit_document', group: 'content'}, {id_page: 'vca-create-project', name: 'Create Project', icon: 'add_notes', group: 'content'}, {id_page: 'vca-upload-content', name: 'Upload Content', icon: 'upload', group: 'content'}, 
      {id_page: 'vca-student-dashboard', name: 'Dashboard', icon: 'dashboard', group: 'admin'},{id_page: 'vca-student-manager', name: 'Student Manager', icon: 'manage_accounts', group: 'admin'},
      {id_page: 'vca-manage-ressource', name: 'Manager Ressource', icon: 'school', group: 'admin'},
      {id_page: 'vca-promotion', name: 'Promotion', 'icon': 'thumb_up_off_alt', group: 'admin'}, {id_page: 'vca-advertisment', name: 'Advertisment', 'icon': 'campaign', group: 'admin'},
    ];
    virtualClassPages = [{id_page: 'vcl-content-project', name: 'Edit Content', 'icon': 'edit_document', group: 'content'}, {id_page: 'vcl-create-project', name: 'Create Project', icon: 'add_notes', group: 'content'}, {id_page: 'vcl-upload-content', name: 'Upload Content', icon: 'upload', group: 'content'},
      {id_page: 'vcl-student-dashboard', name: 'Dashboard', icon: 'groups', group: 'admin'}, {id_page: 'vcl-student-manager', name: 'Student Manager', icon: 'manage_accounts', group: 'admin'},
      {id_page: 'vcl-manage-ressource', name: 'Manage Ressource', icon: 'school', group: 'admin'},
      {id_page: 'vcl-promotion', name: 'Promotion', 'icon': 'thumb_up_off_alt', group: 'admin'}, {id_page: 'vcl-advertisment', name: 'Advertisment', 'icon': 'campaign', group: 'admin'},
    ];
  
    ngOnInit(){
      if (this.data) {
        this.action = this.data.action || '';
        this.countryData = this.data.country || [];
        this.functionData = this.data.function || [];
        this.userInfos = this.data.user_infos || {};
        this.rowInfos = this.data.row_infos || {authorization: {enovsky: [], virtualcampus: [], virtualclass: []}};
      }
      this.usersManager = this.rowInfos.id_user_manager? [{id: this.rowInfos.id_user_manager, full_name: this.rowInfos.user_manager_full_name, initials: '', email: ''}] : [];
  
      this.countryControl.setValue(this.rowInfos['id_country']);
      this.firstNameControl.setValue(this.rowInfos['first_name']);
      this.lastNameControl.setValue(this.rowInfos['last_name']);
      this.emailControl.setValue(this.rowInfos['email']);
      this.phoneControl.setValue(this.rowInfos['phone']);
      this.promoCodeControl.setValue(this.rowInfos['promo_code']);
      this.privilegeLevelControl.setValue(this.rowInfos['privilege']);
      this.funcionControl.setValue(this.rowInfos['id_function']);

      this.userManagerControl.setValue(this.rowInfos['id_user_manager']);
      this.selectedUserManager = this.usersManager[0] || null;
      this.contentAcquisitionControl.setValue(this.rowInfos['amount_acquisition']);
      this.contentClassificationControl.setValue(this.rowInfos['amount_classification']);
      this.contentEditionControl.setValue(this.rowInfos['amount_edition']);

      

      this.userManagerSearchControl.valueChanges.pipe(
        filter(query => query && query.length > 2),
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((query) => {
          return this.apiService.queryData(config.master.ndapi.url+'/enovsky/web/administration/search_user', {search_key: query}, this.userInfos['access_token'])
        })).subscribe((options) => {
        this.usersManager = options;
      });
      
    }
    applyUpdate(){
      let data = {
        action: this.action,
        row_infos: this.rowInfos,
        id_country: this.countryControl.value,
        first_name: this.firstNameControl.value,
        last_name: this.lastNameControl.value,
        email: this.emailControl.value,
        phone: this.phoneControl.value,
        promo_code: this.promoCodeControl.value,
        privilege: this.privilegeLevelControl.value,
        id_function: this.funcionControl.value,
        password: this.passwordControl.value,
        id_user_manager: this.userManagerControl.value,
        amount_acquisition: this.contentAcquisitionControl.value,
        amount_classification: this.contentClassificationControl.value,
        amount_edition: this.contentEditionControl.value
      }
      this.inProgress = true;
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/administration/update_user', data, this.userInfos['access_token']).subscribe((response:any)=>{
        
        this.helper.showToast(response.message); 
        this.inProgress = false;
      });
    }

    checkPage(key:string, page:any, element:any){
      let authorizedPages = this.rowInfos['authorization'][key];
      let newPage = page.id_page;
      element.checked ? authorizedPages.push(newPage): authorizedPages = authorizedPages.filter((item:any)=>item !== newPage);
      this.rowInfos['authorization'][key] = authorizedPages
    }
    onManagerChange(userId: number): void {
      this.selectedUserManager = this.usersManager.find(user => user.id === userId) || null;
    }
    onPhoneInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      let value = input.value.replace(/[^0-9+]/g, '');

      value = value.replace(/\+/g, '');

      if (input.value.startsWith('+')) {
          value = '+' + value;
      }

      input.value = value;
      this.phoneControl.setValue(value, { emitEvent: false });
    }
    closeDialog(){
      this.dialogRef.close();
    }
}
